import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './areas/user/auth/guards/auth.guard.service';
import { HomeRedirectGuardService } from './areas/user/auth/guards/home-redirect.guars.service';
import { SubscriberRoleGuardService } from './areas/user/auth/guards/subscriber.role.guard.service';
import { PageNotFoundComponent } from './layouts/page-not-found/page-not-found.component';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        canActivate: [HomeRedirectGuardService],
        loadChildren: () => import('./areas/home/home.module').then(m => m.HomeModule),
    },
    {
        path: 'profile',
        loadChildren: () => import('./areas/user/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuardService]
    },
    {
      path: 'home',
      loadChildren: () => import('./areas/user/dashboard/dashboard.module').then(m => m.DashboardModule),
      canActivate: [AuthGuardService]
    },
    {
        path: 'settings',
        loadChildren: () => import('./areas/user/account-settings/account-settings.module').then(m => m.AccountSettingsModule),
        canActivate: [AuthGuardService]
    },
    {
        path: 'global-operation',
        loadChildren: () => import('./areas/user/global-operation/global-operation.module').then(m => m.GlobalOperationModule),
        canActivate: [AuthGuardService, SubscriberRoleGuardService]
    },
    {
        path: 'sign-up',
        loadChildren: () => import('./areas/user/sign-up/sign-up.module').then(m => m.SignUpModule)
    },
    {
        path: 'password',
        loadChildren: () => import('./areas/user/password/password.module').then(m => m.PasswordModule)
    },
    {
        path: 'admin',
        loadChildren: () => import('./areas/admin/admin.module').then(m => m.AdminModule)
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [
        RouterModule
    ],
    providers: [AuthGuardService, HomeRedirectGuardService, SubscriberRoleGuardService]
})
export class AppRoutingModule { }
